//Scroll to
function scrollTo(selector, offset = 50) {
 $('html, body').animate({
    scrollTop: $(selector).offset().top - offset
}, 200);
}




//Enlarge images
$('.bigimg').on('click', function(e) {
    $('#imgViewer').html('').append( $(e.currentTarget).clone().removeClass('img-responsive').removeClass('img-thumbnail') )
    $('#viewImg').modal('show')
})


// Scroll to contact
$('.to-contact').on('click', () => {
    scrollTo('#contact-us');
})

//Cooming soon
 document.addEventListener("DOMContentLoaded", () => {
const comingSoonElements = document.querySelectorAll('.comingsoon');
const comingSoonModalEl = document.getElementById('comingSoon');

if (comingSoonModalEl) {
    // Inizializza il modal di Bootstrap
    const comingSoonModal = new bootstrap.Modal(comingSoonModalEl);
    
    comingSoonElements.forEach(element => {
    element.addEventListener('click', event => {
        event.preventDefault();
        comingSoonModal.show();
    });
    });
}
});


function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
}

// Site navigation (burger + scrolled state)
(function () {
	var nav = document.getElementById('siteNav');
	var burger = document.getElementById('siteNavBurger');
	var menu = document.getElementById('siteNavMenu');
	if (nav) {
		var onScroll = function () { nav.classList.toggle('scrolled', window.pageYOffset > 10); };
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	}
	if (burger && menu) {
		var set = function (open) {
			menu.classList.toggle('open', open);
			burger.classList.toggle('open', open);
			burger.setAttribute('aria-expanded', String(open));
		};
		burger.addEventListener('click', function () { set(!menu.classList.contains('open')); });
		menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
	}
})();

// Theme toggle (dark <-> light, persisted in localStorage)
(function () {
	var root = document.documentElement;
	var btn = document.getElementById('siteThemeToggle');
	if (!btn) return;
	var sync = function () {
		var light = root.getAttribute('data-theme') === 'light';
		var label = light ? 'Switch to dark theme' : 'Switch to light theme';
		btn.setAttribute('aria-label', label);
		btn.setAttribute('title', label);
	};
	sync();
	btn.addEventListener('click', function () {
		var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
		root.setAttribute('data-theme', next);
		try { localStorage.setItem('ts-theme', next); } catch (e) {}
		sync();
	});
})();
